module.exports = __webpack_public_path__ + "static/media/Voordekunst Logo.1672c520.png";